var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDenmarkDanskeLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 111",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.088 61.594h7.941l-.462 5.817H3.886l1.939-23.822h6.74l-1.477 18.005zm32.871-12.096h5.632l-1.477 18.005h6.74l1.477-18.005h5.632l.462-5.817H44.42l-.462 5.817zm20.313-5.909-.462 5.909h5.632l-1.477 18.005h6.74l1.477-18.005h5.632l.554-5.909H64.272zM43.958 55.5a12.41 12.41 0 0 1-12.465 12.465A12.41 12.41 0 0 1 19.028 55.5c0-6.925 5.632-12.465 12.465-12.465A12.41 12.41 0 0 1 43.958 55.5zm-7.664 0c0-2.678-2.124-4.801-4.801-4.801s-4.801 2.124-4.801 4.801 2.124 4.801 4.801 4.801 4.801-2.124 4.801-4.801zm70.82 0a12.41 12.41 0 0 1-12.465 12.465A12.41 12.41 0 0 1 82.184 55.5a12.41 12.41 0 0 1 12.465-12.465c6.833 0 12.465 5.54 12.465 12.465zm-7.756 0c0-2.678-2.124-4.801-4.801-4.801s-4.801 2.124-4.801 4.801 2.124 4.801 4.801 4.801 4.801-2.124 4.801-4.801z",
    fill: "#ee0008"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenmarkDanskeLotto);
export default __webpack_public_path__ + "static/media/denmark_danske_lotto.68f763e24c1d0cf538dbf4cfdd6561a4.svg";
export { ForwardRef as ReactComponent };